import React, { Component } from "react";
import styled from "styled-components";
import { NavLink } from "react-router-dom";
import logo from "../../assets/img/logo.svg";

class DesktopMenu extends Component {
  render() {
    return (
      <MenuContainer>
        <MenuItem>
          <MenuLink
            exact
            to="/services"
            activeStyle={{ textDecoration: "underline" }}
          >
            Services
          </MenuLink>
        </MenuItem>
        <MenuItem>
          <MenuLink
            exact
            to="/gallery"
            activeStyle={{ textDecoration: "underline" }}
          >
            Gallery
          </MenuLink>
        </MenuItem>
        <HomeMenuItem>
          <MenuLink exact to="/" activeStyle={{ textDecoration: "underline" }}>
            <MainLogo src={logo} />
          </MenuLink>
        </HomeMenuItem>
        <MenuItem>
          <MenuLink
            exact
            to="/feedback"
            activeStyle={{ textDecoration: "underline" }}
          >
            Feedback
          </MenuLink>
        </MenuItem>
        <MenuItem>
          <MenuLink
            exact
            to="/contact"
            activeStyle={{ textDecoration: "underline" }}
          >
            Contact
          </MenuLink>
        </MenuItem>
      </MenuContainer>
    );
  }
}

const MenuContainer = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
  padding-left: 10px;
  padding-right: 10px;
  width: 940px;
  font-family: "Pathway Gothic One";
  // height: 100px;
  font-weight: 200;
  margin-left: auto;
  margin-right: auto;
  display: flex;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
  @media only screen and (max-width: 980px) {
    width: 100%;
    padding: 20px 0;
    display: none;
    // display: block;
  }
`;

const MenuItem = styled.li`
  // background: #ffffff;
  float: left;
  width: 25%;
  margin: 72px 0 0 0;
  font-size: 18px;
  line-height: 18px;
  // height: 100px;
  // line-height: 100px;
  padding: 0;
  color: #6c6c6c;
  flex: 1 1 auto;
  text-align: center;
  @media only screen and (max-width: 980px) {
    flex: none;
    width: 100%;
    padding: 5px 0 5px 0;
    float: none;
    margin: 0;
  }
`;

const HomeMenuItem = styled.li`
  // background: #ffffff;
  float: left;
  text-align: center;
  width: 25%;
  margin: 0;
  font-size: 18px;
  height: 100px;
  padding: 0;
  color: #ffffff;
  flex: 1 1 auto;
  text-align: center;
  @media only screen and (max-width: 980px) {
    flex: none;
    width: 100%;
    padding: 5px 0 5px 0;
    float: none;
  }
`;

const MenuLink = styled(NavLink)`
  text-decoration: none;
  color: #ffffff;
  width: 100%;
  display: block;
  text-transform: uppercase;
`;

const MainLogo = styled.img`
  height: 75px;
  display: block;
  margin: 0 auto;
  overflow: hidden;
  padding: 12px 0 0 0;
  @media only screen and (max-width: 980px) {
    margin: 0;
    width: auto;
    padding: 10px 0;
    height: 45px;
  }
`;

export default DesktopMenu;



// WEBPACK FOOTER //
// ./src/components/navigation/DesktopMenu.js